import React, { useRef, useState, useEffect } from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
// import { Parallax } from "react-scroll-parallax";
import Slider from "react-slick";
import "../../../sass/slick/slick.min.scss";
import "../../../sass/slick/slick-theme.min.scss";

const Perform2023SpeakersSection = ({ data }) => {

    const sliderRef = useRef(null);
    const [activeSlide, setActiveSlide] = useState(0);

    let settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
        beforeChange: (current, next) => setActiveSlide(next),
        afterChange: current => setActiveSlide(current)
    };

    const [hideAlert, setHideAlert] = useState(false);

    useEffect(() => {
        hideAlertCheck(false, 0);
    }, []);

    const hideAlertCheck = (val, index) => {
        setHideAlert(val);
        setTimeout(() => {
            if (sliderRef.current){
                sliderRef.current.slickGoTo(index);
            }
        }, 100);
    }

    return (
        <div className="cp-perform2023Speakers">
            <div className="cp-perform2023Speakers__inner" data-aos="fade-up">
                {data.perform23SpeakersSectionHeader &&
                    <h2>{data.perform23SpeakersSectionHeader}</h2>
                }
                {data.perform23SpeakersSectionGrid &&
                    // <Parallax y={[0, 0]} speed={10}>
                    <div className="cp-perform2023Speakers__grid l--flex">
                        {data.perform23SpeakersSectionGrid.map((speakers, index) => (
                            <button className="cp-perform2023Speakers__grid-speaker" key={index} onClick={() => hideAlertCheck(true, index)}>
                                {speakers.speakerThumb &&
                                    <GatsbyImage className="l--borderRadiusLarge" image={getImage(speakers.speakerThumb.gatsbyImage)} alt={speakers.speakerThumb.altText} />
                                }
                                {speakers.speakerName &&
                                    <h3>{speakers.speakerName}</h3>
                                }
                                {speakers.speakerTitle &&
                                    <span>{speakers.speakerTitle}</span>
                                }
                            </button>
                        ))}
                    </div>
                    // </Parallax>
                }
                {data.perform23SpeakersSectionButton &&
                    <div className="l-buttonWrap">
                        <a className="l-button" href={data.perform23SpeakersSectionButton.url} target={data.perform23SpeakersSectionButton.target}>{data.perform23SpeakersSectionButton.title}</a>
                    </div>
                }
            </div>
            {hideAlert &&
                <div className="l-speakersPopup">
                    <div className="l-speakersPopup__inner">
                        <Slider {...settings} ref={sliderRef}>
                            {data.perform23SpeakersSectionGrid.map((speakers, index) => (
                                <div className="l-speakersPopup__speaker l--flex" key={index}>
                                    <div className="l-speakersPopup__speaker-thumb">
                                        {speakers.speakerThumb &&
                                            <GatsbyImage className="l--borderRadiusLarge" image={getImage(speakers.speakerThumb.gatsbyImage)} alt={speakers.speakerThumb.altText} />
                                        }
                                    </div>
                                    <div className="l-speakersPopup__speaker-details">
                                        {speakers.speakerName &&
                                            <h3>{speakers.speakerName}</h3>
                                        }
                                        {speakers.speakerTitle &&
                                            <span>{speakers.speakerTitle}</span>
                                        }
                                        <div className="l--speakersSocial l--flex">
                                            {speakers.speakerFacebookLink &&
                                                <a target="_blank" rel="noreferrer" href={speakers.speakerFacebookLink}>
                                                    <StaticImage src='../../../images/icon-twitter-black.svg' alt="Twitter" />
                                                </a>
                                            }
                                            {speakers.speakerLinkedinLink &&
                                                <a target="_blank" rel="noreferrer" href={speakers.speakerLinkedinLink}>
                                                    <StaticImage src='../../../images/icon-linkedin-black.svg' alt="LinkedIn" />
                                                </a>
                                            }
                                        </div>
                                        {speakers.speakerBio &&
                                            <div dangerouslySetInnerHTML={{ __html: speakers.speakerBio }} />
                                        }
                                    </div>
                                </div>
                            ))}
                        </Slider>
                        <div className="l-speakerPagination">{activeSlide + 1} / {data.perform23SpeakersSectionGrid.length}</div>
                        <button onClick={() => hideAlertCheck(false, 0)} className="l-closeSpeaker">
                            <StaticImage src='../../../images/icon-speakersClose.svg' alt="Twitter" />
                        </button>
                    </div>
                    <button onClick={() => hideAlertCheck(false, 0)} className="l-alertBackground"></button>
                </div>
            }
        </div>
    )
}
export default Perform2023SpeakersSection;